// 登录状态
export const loginStatus = state => state.loginStatus



// WEBPACK FOOTER //
// ./src/vuex/modules/user/getters.js